import { Injectable } from '@angular/core';
import { ICard, ICardUserVariant } from '../../model/i-card';

export interface ICardRatingResult {
  points: number;
  maxPoints: number;
}

@Injectable({
  providedIn: 'root'
})
export class RaitingSystem {
  successesInGame(card: ICard): ICardRatingResult {
    const userVariants = card.data.userList ?? [];

    switch(card.data.variants_type){
      case 'checkbox':
        return {
          points: this.sumSelectedPoints(userVariants),
          maxPoints: this.sumCorrectPoints(userVariants),
        };
      case 'radiobutton':
        return {
          points: this.sumSelectedPoints(userVariants),
          maxPoints: this.highestCorrectPoint(userVariants),
        };
      default:
        console.info(`variants_type = ${card.data.variants_type}`);
        return { points: 0, maxPoints: 0 };
    }
  }

  calculationMaxPoints(card: ICard): ICardRatingResult {
    const maxPoints = (card.data.variants ?? []).reduce(
      (max, variant) => Math.max(max, variant.v_points),
      0,
    );
    return { points: 0, maxPoints };
  }

  private sumSelectedPoints(userVariants: readonly ICardUserVariant[]): number {
    return userVariants.reduce(
      (points, variant) => points + (variant.variant ? variant.v_points : 0),
      0,
    );
  }

  private sumCorrectPoints(userVariants: readonly ICardUserVariant[]): number {
    return userVariants.reduce(
      (points, variant) => points + (variant.v_points > 0 ? variant.v_points : 0),
      0,
    );
  }

  private highestCorrectPoint(userVariants: readonly ICardUserVariant[]): number {
    return userVariants.reduce(
      (max, variant) => Math.max(max, variant.v_points),
      0,
    );
  }
}
